import React from 'react'
import url from 'front-end-core/core/url'
import { LEG_COMMENTS, QA_COMMENTS } from 'constants/feature-flags'
import { FLAVOUR_TITLES, ALL_FLAVOURS } from 'constants/flavours'
import { COMMENTS } from 'constants/controllers'
import { Tab } from 'pages/search/Header'
import { ContentSelector } from 'components/shared/ContentSelector'

const FlavourSelector = ({
  selected,
  order,
  users,
  privacy,
  archived,
  preview,
  aol
}) => {
  const optionLink = (category) => (
    url(COMMENTS, { aol }, { category, order, users, privacy, archived, preview })
  )

  const tabs = QA_COMMENTS && ALL_FLAVOURS.map(category => ({
    title: FLAVOUR_TITLES[category],
    href: selected === category ? null : optionLink(category),
    isActive: selected === category,
    flavour: category
  }))

  if (LEG_COMMENTS) {
    tabs.push({
      title: 'Legislation',
      href: selected === 'legislation' ? null : optionLink('legislation'),
      isActive: selected === 'legislation',
      flavour: 'legislation'
    })
  }

  return (
    <ContentSelector {...{ selected }} listCxNames='flex list-reset pa0 ma0 w-100'>
      {tabs.map(tab => <Tab isAnnotationPage key={tab.flavour} {...tab} />)}
    </ContentSelector>
  )
}

export default FlavourSelector
